(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const productsGrid = document.getElementById('products-grid');
  const loadMoreBtn = document.getElementById('load-more-btn');
  const infiniteScrollLoading = document.getElementById('infinite-scroll-loading');
  const paginationData = document.getElementById('pagination-data');
  
  let isLoading = false;
  let hasNextPage = paginationData.dataset.hasNext === 'true';
  let nextUrl = paginationData.dataset.nextUrl;
  
  // Infinite scroll functionality
  function setupInfiniteScroll() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && hasNextPage && !isLoading) {
          loadMoreProducts();
        }
      });
    }, {
      rootMargin: '100px'
    });
    
    // Observe the load more button or last product
    const targetElement = loadMoreBtn || productsGrid.lastElementChild;
    if (targetElement) {
      observer.observe(targetElement);
    }
  }
  
  // Load more products function
  async function loadMoreProducts() {
    if (isLoading || !hasNextPage) return;
    
    isLoading = true;
    infiniteScrollLoading.style.display = 'flex';
    if (loadMoreBtn) loadMoreBtn.style.display = 'none';
    
    try {
      const response = await fetch(nextUrl);
      const html = await response.text();
      
      // Parse the new HTML
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      // Extract new products
      const newProducts = doc.querySelectorAll('.product-card');
      const newPaginationData = doc.getElementById('pagination-data');
      
      // Add new products to the grid
      newProducts.forEach(product => {
        productsGrid.appendChild(product);
      });
      
      // Update pagination data
      if (newPaginationData) {
        hasNextPage = newPaginationData.dataset.hasNext === 'true';
        nextUrl = newPaginationData.dataset.nextUrl;
      } else {
        hasNextPage = false;
      }
      
      // Hide loading indicator
      infiniteScrollLoading.style.display = 'none';
      
      // If no more pages, hide load more button
      if (!hasNextPage && loadMoreBtn) {
        loadMoreBtn.style.display = 'none';
      }
      
    } catch (error) {
      console.error('Error loading more products:', error);
      infiniteScrollLoading.style.display = 'none';
      if (loadMoreBtn) loadMoreBtn.style.display = 'block';
    }
    
    isLoading = false;
  }
  
  // Load more button click handler
  if (loadMoreBtn) {
    loadMoreBtn.addEventListener('click', loadMoreProducts);
  }
  
  // Initialize infinite scroll
  setupInfiniteScroll();
});

  } catch(e) { console.error(e); }
})();
})();
